import React, { useEffect } from "react"
import { useValidatorSeeker } from "@ui-seeker/app"
import { Grid } from "@mui/material"
import { array, object } from "yup"

import { AppProvidersAutocomplete, AppTiersAutocomplete } from "@components"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { BACKEND_APIS } from "@constants"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"

export default function MainProvidersRequired() {
	const {
		dataInfo: mainProvider, setDataInfo: setMainProvider
	} = useAlertsDataInfo(alertsDrawerData.peek().mainProvider || [])
	const {
		dataInfo: mainTiers, setDataInfo: setMainTiers
	} = useAlertsDataInfo(alertsDrawerData.peek().mainTiers || [])
	const {
		dataInfo: providersByTiers, setDataInfo: setProvidersByTiers
	} = useAlertsDataInfo((alertsDrawerData.peek()?.tiers && alertsDrawerData.peek().providers) && alertsDrawerData.peek().providers || [])

	const { errors, isValid } = useValidatorSeeker({ mainProvider: mainProvider.value }, object({
		mainProvider: array().min(1, 'Must provide at least one main provider')
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.value, mainProvider: isValid }
	}, [JSON.stringify(errors)])

	return <Grid container spacing={3}>
		<Grid item xs={6}>
			<AppTiersAutocomplete
				multiple
				onChange={e => {
					setMainProvider(e.target.value.reduce((acc, curr) => [...acc, ...providersByTiers.value.find(t => t.key === curr).providers], []), 'mainProvider')
					setMainTiers(e.target.value, 'mainTiers')
				}}
				value={mainTiers.value}
				onFinishAjax={options => {
					setProvidersByTiers(options.map(t => ({
						key: t.value, providers: t.providers
					})), 'providersByTiers')
				}}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
				label="Main tiers"
				placeholder="All tiers for main provider"
			/>
		</Grid>
		<Grid item xs={6}>
			<AppProvidersAutocomplete
				label="Main Providers"
				value={mainProvider.value}
				onChange={e => setMainProvider(e.target.value, 'mainProvider')}
				disabled={!!mainTiers.value.length}
				error={errors.mainProvider}
			/>
		</Grid>
	</Grid>

}